import React from 'react';
import { BarChart, DollarSign } from 'lucide-react';

const SalesTab = ({ lot }) => {
  // Calcular el total de ventas
  const totalSales = lot.recentSales.reduce((sum, sale) => sum + (sale.quantity * sale.price), 0);
  const totalQuantitySold = lot.recentSales.reduce((sum, sale) => sum + sale.quantity, 0);

  return (
    <div className="p-4 bg-white dark:bg-gray-800">
      <div className="space-y-4">
        {/* Resumen de ventas */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
            <div className="text-sm text-gray-500 dark:text-gray-400">Total vendido</div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
              ${totalSales.toLocaleString()}
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
            <div className="text-sm text-gray-500 dark:text-gray-400">Cantidad vendida</div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
              {totalQuantitySold} {lot.unit}
            </div>
          </div>
        </div>

        {/* Fluctuación de precios */}
        <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
          <h3 className="font-medium mb-2 flex items-center gap-2 text-gray-900 dark:text-white">
            <BarChart className="w-4 h-4" />
            Fluctuación de precios
          </h3>
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-gray-500 dark:text-gray-400">Precio inicial</div>
              <div className="text-lg font-medium text-gray-900 dark:text-white">
                {lot.minPrice > 0 ? `$${lot.minPrice.toLocaleString()}` : '-'}
              </div>
            </div>
            <DollarSign className="w-5 h-5 text-gray-400" />
            <div className="text-right">
              <div className="text-sm text-gray-500 dark:text-gray-400">Precio actual</div>
              <div className="text-lg font-medium text-gray-900 dark:text-white">
                {lot.minPrice > 0 ? `$${lot.minPrice.toLocaleString()}` : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* Lista de ventas */}
        <div className="space-y-3">
          <h3 className="font-medium text-gray-900 dark:text-white">Ventas realizadas</h3>
          {lot.recentSales.length > 0 ? (
            lot.recentSales.map((sale) => (
              <div key={sale.id} className="bg-white dark:bg-gray-700 border dark:border-gray-600 rounded-lg p-3">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="font-medium text-gray-900 dark:text-white">{sale.client}</div>
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                      {sale.quantity} {lot.unit} × ${sale.price.toLocaleString()}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-blue-600 dark:text-blue-400">
                      ${(sale.quantity * sale.price).toLocaleString()}
                    </div>
                    <div className="text-sm text-gray-500 dark:text-gray-400">{sale.timestamp}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500 dark:text-gray-400 py-8 bg-gray-50 dark:bg-gray-700 rounded-lg">
              No hay ventas registradas
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesTab; 